import { useMemo } from 'react';
import { usePreview } from 'react-dnd-preview';

export const useIsGlobalDragging = () => {
  const preview = usePreview() as { display: boolean; monitor: { isDragging: () => boolean } };
  return useMemo(() => preview.display && preview.monitor.isDragging(), [preview.display, preview?.monitor]);
};
